<template>
  <div class="license">
    <transition name="overlay-slide">
      <div class="license--delete-overlay" v-if="deleting">
        <button class="btn btn__small btn__red" @click.self="toggleDeleting">Cancel</button>
        <button class="btn btn__small btn__green" @click.self="deleteLicense">Delete</button>
      </div>
    </transition>
    <div class="license--container">
      <div class="text__bold text__center license--state">{{ license.state }}</div>
      <simplebar class="license--overflow" data-simplebar-auto-hide="false">
        <div class="license--text">
          <p v-html="license.content"></p>
        </div>
      </simplebar>
    </div>
    <div class="license--change flex__around">
      <div class="license--change-delete text__bold pointer" @click="toggleDeleting">
        <font-awesome-icon icon="times" size="lg" class="icon mr-10" />Delete
      </div>
      <div class="license--change-edit text__bold pointer" @click="setActiveLicense">
        <font-awesome-icon icon="edit" size="lg" class="icon mr-10" />Edit
      </div>
    </div>
  </div>
</template>

<script>
// delete to api from here: using _id from the license passed in
import { mapActions } from "vuex";
export default {
  props: ["license"],
  data() {
    return {
      deleting: false,
      form: {
        _id: this.license._id,
        state: this.license.state,
        content: this.license.content,
        website: this.license.website
      }
    };
  },
  methods: {
    ...mapActions(["startSetActiveLicense", "startDeleteLicense"]),
    setActiveLicense() {
      this.startSetActiveLicense(this.license);
    },
    toggleDeleting() {
      this.deleting = !this.deleting;
    },
    deleteLicense() {
      this.startDeleteLicense(this.form);
    }
  }
};
</script>

<style scoped lang="scss">
</style>